<template>
    <div class="container">
      <!--nav-->
      <div class="top pc">
        <div class="commen">
          <div class="topa fl"></div>
          <div class="topb fr">
            <div class="topb_a fl">
              <a href="#">
                <img src="@/view/images/y2.png">
                <p>控制台</p>
                <div class="clearfix"></div>
              </a>
            </div>
            <!--登录前-->
            <div class="topb_b fl">
              <a href="javascript:void(0);" @click="login">登录</a>
              <span>|</span>
              <a href="javascript:void(0);" @click="register">注册 </a>
            </div>
            <!--登录后-->
            <!--
                        <div class="topb_c fl">
                            <a href="#">消息<span>2</span></a>
                            <div class="topb_ca fl">
                                <p>一瞬网络</p>
                                <div class="topb_cax">
                                    <a href="#">个人中心</a>
                                    <a href="#">我的课程</a>
                                    <a href="#">我的订单</a>
                                    <a href="#">退出登录</a>
                                </div>
                            </div>
                        </div>
            -->
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="logo pc">
        <div class="commen">
          <div class="logoa fl">
            <a href="#">
              <img src="@/view/images/LOGO-1.png">
            </a>
          </div>
          <div class="nav fl">
            <div class="nava fl">
              <p><a href="javascript:void(0);">首页</a></p>
            </div>
            <div class="nava fl">
              <p><a href="javascript:void(0);">解决方案</a></p>
              <div class="navb navc">
                <div class="navca fl">
                  <h6><a href="jjfa.html">印刷管家服务解决方案</a></h6>
                  <h5>
                    <a href="#"><span></span>色彩管理体系构建</a>
                    <a href="#"><span></span>色彩管理体系优化</a>
                    <a href="#"><span></span>质量评测方法建立</a>
                    <a href="#"><span></span>印刷管家服务APP</a>
                    <a href="#"><span></span>人才赋能计划</a>
                    <a href="#"><span></span>印刷设备校正</a>
                  </h5>
                </div>
                <div class="navca fr">
                  <h6><a href="javascript:void(0);">印刷数字化工厂解决方案</a></h6>
                  <h5 class="fl">
                    <a href="#"><span></span>MES</a>
                    <a href="#"><span></span>WMS</a>
                    <a href="#"><span></span>IIOT</a>
                    <a href="#"><span></span>ERP</a>
                    <a href="#"><span></span>APS</a>
                    <a href="#"><span></span>PLM</a>
                  </h5>
                  <h5 class="fl">
                    <a href="#"><span></span>BI</a>
                    <a href="#"><span></span>QMS</a>
                    <a href="#"><span></span>CPS</a>
                    <a href="#"><span></span>CRM</a>
                    <a href="#"><span></span>CMS</a>
                    <a href="#"><span></span>AIDS</a>
                  </h5>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
            <!-- <div class="nava fl">
              <p><a href="javascript:void(0);">客户案例</a></p>
            </div> -->
            <div class="nava fl">
              <p><a href="javascript:void(0);">学术园地</a></p>
              <!-- <div class="navb">
                <div class="navba"><a href="xs_l.html">印刷管理培训</a></div>
                <div class="navba"><a href="xs_l.html">印刷技术培训</a></div>
                <div class="navba"><a href="xs_l.html">管理咨询</a></div>
                <div class="navba"><a href="xs_l.html">学员天地</a></div>
              </div> -->
            </div>
            <div class="nava fl">
              <p><a href="javascript:void(0);">新闻资讯</a></p>
              <!-- <div class="navb">
                <div class="navba"><a href="xw_l.html">企业动态</a></div>
                <div class="navba"><a href="xw_l.html">行业资讯</a></div>
                <div class="navba"><a href="xw_l.html">深度阅读</a></div>
              </div> -->
            </div>
            <div class="nava fl">
              <p><a href="javascript:void(0);">关于我们</a></p>
              <!-- <div class="navb">
                <div class="navba"><a href="gy.html">公司介绍</a></div>
                <div class="navba"><a href="gy.html#gy1">企业文化</a></div>
                <div class="navba"><a href="gy.html#gy2">专家团队</a></div>
                <div class="navba"><a href="gy.html#gy3">战略布局</a></div>
                <div class="navba"><a href="gy.html#gy4">联系我们</a></div>
              </div> -->
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="tel fr"><img src="@/view/images/y3.png"></div>
          <div class="clearfix"></div>
        </div>
      </div>
      <!--手机导航-->
      <div class="sjdhgd sjdhgd_n">
        <div class="sjdh mob">
          <div class="sjdha">
            <div class="sjdha_t1 fl"><a href="javascript:void(0);"><img src="@/view/images/logo.png"></a></div>
            <div class="topb fl">
              <div class="topb_a fl">
                <a href="#">
                  <img src="@/view/images/y29.png">
                  <p>控制台</p>
                  <div class="clearfix"></div>
                </a>
              </div>
              <!--登录前-->
              <div class="topb_b fl">
                <a href="javascript:void(0);" @click="login">登录</a>
                <span>|</span>
                <a href="javascript:void(0);" @click="register">注册 </a>
              </div>
              <!--登录后-->

              <!--
                              <div class="topb_c fl">
                                  <a href="#">消息<span>2</span></a>
                                  <div class="topb_ca fl">
                                      <p>一瞬网络</p>
                                      <div class="topb_cax">
                                          <a href="#">个人中心</a>
                                          <a href="#">我的课程</a>
                                          <a href="#">我的订单</a>
                                          <a href="#">退出登录</a>
                                      </div>
                                  </div>
                              </div>
              -->
            </div>
            <div class="sjdha_t2"><img src="@/view/images/k52.png"></div>
            <div class="clearfix"></div>
          </div>
          <div class="huakuai">
            <div class="sjdhb fr">
              <div class="guanbi"><img src="@/view/images/k53.png"><div class="clearfix"></div></div>
              <div class="sjdhb_a"><h6><a href="javascript:void(0);">首页</a></h6></div>
              <div class="sjdhb_a"><h6><a href="javascript:void(0);">解决方案</a></h6>
                <div class="sjdhb_aa">
                  <p class="sjdhb_p"><a href="javascript:void(0);">印刷管家服务解决方案</a></p>
                  <p class="sjdhb_p"><a href="javascript:void(0);">印刷数字化工厂解决方案</a></p>
                </div>
              </div>
              <!-- <div class="sjdhb_a"><h6><a href="javascript:void(0);">客户案例</a></h6></div> -->
              <div class="sjdhb_a"><h6><a href="javascript:void(0);">学习园地</a></h6>
                <!-- <div class="sjdhb_aa">
                  <p class="sjdhb_p"><a href="javascript:void(0);">印刷管理培训</a></p>
                  <p class="sjdhb_p"><a href="javascript:void(0);">印刷技术培训</a></p>
                  <p class="sjdhb_p"><a href="javascript:void(0);">印刷技术培训</a></p>
                  <p class="sjdhb_p"><a href="javascript:void(0);">学员天地</a></p>
                </div> -->
              </div>
              <div class="sjdhb_a"><h6><a href="javascript:void(0);">新闻资讯</a></h6>
                <!-- <div class="sjdhb_aa">
                  <p class="sjdhb_p"><a href="javascript:void(0);">企业动态</a></p>
                  <p class="sjdhb_p"><a href="javascript:void(0);">行业资讯</a></p>
                  <p class="sjdhb_p"><a href="javascript:void(0);">深度阅读</a></p>
                </div> -->
              </div>
              <div class="sjdhb_a"><h6><a href="javascript:void(0);">关于我们</a></h6>
                <!-- <div class="sjdhb_aa">
                  <p class="sjdhb_p"><a href="javascript:void(0);">公司介绍</a></p>
                  <p class="sjdhb_p"><a href="javascript:void(0);">企业文化</a></p>
                  <p class="sjdhb_p"><a href="javascript:void(0);">专家团队</a></p>
                  <p class="sjdhb_p"><a href="javascript:void(0);">战略布局</a></p>
                  <p class="sjdhb_p"><a href="javascript:void(0);">联系我们</a></p>
                </div> -->
              </div>			</div>
            <div class="clearfix"></div>
          </div>

        </div>
      </div>
      <!--隐私说明-->
      <div class="yinsi">
        <div class="commen">
          <div class="yinsa">
            <h6>印工社——隐私政策说明</h6>
            <p>印工社（青岛）数字科技有限公司（以下简称“印工社”或“我们”）深知您的隐私对您的重要性，并充分尊重您的隐私。 在同意向我们提交您的个人数据之前，请您仔细阅读并理解本《隐私政策声明》（以下简称“本声明”）。 为了给您提供更准确、更有个性化的服务，我们会按照本隐私权政策的规定使用和披露您的个人信息。除本隐私权政策另有规定外， 在未征得您事先许可的情况下，我们不会将这些信息对外披露或向第三方提供。您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。 本隐私权政策属于本应用服务使用协议不可分割的一部分。

              <br><br>1. 适用范围
              <br>(a) 在您注册本应用帐号时，您根据本应用要求提供的个人注册信息；
              <br>(b) 在您使用本应用网络服务，或访问本应用平台网页时，本应用自动接收并记录的您的浏览器和计算机上的信息， 包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；
              <br>(c) 本应用通过合法途径从商业伙伴处取得的用户个人数据。
              <br>您了解并同意，以下信息不适用本隐私权政策：
              <br>(a) 您在使用本应用平台提供的搜索服务时输入的关键字信息；
              <br>(b) 本应用收集到的您在本应用发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；
              <br>(c) 违反法律规定或违反本应用规则行为及本应用已对您采取的措施。

              <br><br>2. 信息使用
              (<br>a)本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可， 或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务，且在该服务结束后， 其将被禁止访问包括其以前能够访问的所有这些<br>资料。
              (b) 本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。 任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。
              <br>(c) 为服务用户的目的，本应用可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息， 或者与本应用合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。

              <br><br>3. 信息披露
              <br>在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：
              <br>(a) 经您事先同意，向第三方披露；
              <br>(b)为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；
              <br>(c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；
              <br>(d) 如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；
              <br>(e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；
              <br>(f) 在本应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本应用有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。
              <br>(g) 其它本应用根据法律、法规或者网站政策认为合适的披露。

              <br><br>4. 信息存储和交换
              <br>本应用收集的有关您的信息和资料将保存在本应用及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本应用收集信息和资料所在地的境外并在境外被访问、存储和展示。

              <br><br>5. Cookie的使用
              <br>(a) 在您未拒绝接受cookies的情况下，本应用会在您的计算机上设定或取用cookies ，以便您能登录或使用依赖于cookies的本应用平台服务或功能。本应用使用cookies可为您提供更加周到的个性化服务，包括推广服务。
              <br>(b) 您有权选择接受或拒绝接受cookies。您可以通过编辑浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的本应用网络服务或功能。
              <br>(c) 通过本应用所设cookies所取得的有关信息，将适用本政策。

              <br><br>6. 信息安全
              <br>(a) 本应用帐号均有安全保护功能，请妥善保管您的用户名及密码信息。本应用将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。

              <br><br>7.本隐私政策的更改
              <br>(a)如果决定更改隐私政策，我们会在本政策中、本公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息， 哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。
              <br>(b)本公司保留随时编辑本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知的形式告知。

              <br><br>为防止向第三方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。

            </p>
          </div>
          <div class="yjd">
            <p>Copyright©  2019-2021   印工社（青岛）数字科技有限公司  All Rights Reserved<span>|</span><a
            href="https://beian.miit.gov.cn"
            target="_banck"
            style="corsor:pointer"
          >
            鲁ICP备20000134号-3</a
          ><span></span><a href="https://beian.mps.gov.cn/#/query/webSearch?code=37021402002207\"target="_banck">鲁公网安备 37021402002207号</a><span class="span1">|</span>网站建设：<a href="#">印工社</a></p>
          </div>
        </div>
      </div>

      <!--悬浮窗 -->
      <div class="xfk pc">
        <div class="xfka">
          <a>400-999-2025</a>
        </div>
        <div class="xfkb">
          <a href="#"></a>
        </div>
        <div class="xfkc">
          <a>微信二维码</a>
          <img src="@/view/images/ewm.png">
        </div>
        <div class="yb_top">
          <a href="#"></a>
        </div>
      </div>

    </div>
</template>

<script>
export default {
  name: 'privacyName',
  data() {
    return {

    };
  },
  methods: {
    init() {

    },
    login() {
      document.title = '登录';
      this.$router.push({ path: '/login' });
    },
    register() {
      document.title = '注册';
      this.$router.push({ path: '/register' });
    },
  },
  mounted() {

  },
  created() {
    this.init();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/privacy.vue